<template>
    <hr/>
</template>

<script>
  export default {
      name: 'Separator',
      components: {
      },
      props: {
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
          }
      },
      methods: {
      }
  }
</script>